/* tslint:disable */
/* eslint-disable */
/**
 * Midcoast Water Bureau API
 * Backend API documentation for Midcoast Water Bureau application. This API provides endpoints for user management, device monitoring, water meter measurements, and notification systems.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: support@nucleus3.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DeviceCompositeData } from '../n3-backend-open-api-gen/model';
/**
 * CompositeDataV2ControllerApi - axios parameter creator
 */
export const CompositeDataV2ControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceWithMeasurements: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDeviceWithMeasurements', 'id', id)
            const localVarPath = `/api/v2/composite-data/devices/{id}/with-measurements`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompositeDataV2ControllerApi - functional programming interface
 */
export const CompositeDataV2ControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompositeDataV2ControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceWithMeasurements(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceCompositeData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceWithMeasurements(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompositeDataV2ControllerApi.getDeviceWithMeasurements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompositeDataV2ControllerApi - factory interface
 */
export const CompositeDataV2ControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompositeDataV2ControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceWithMeasurements(id: number, options?: RawAxiosRequestConfig): AxiosPromise<DeviceCompositeData> {
            return localVarFp.getDeviceWithMeasurements(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompositeDataV2ControllerApi - object-oriented interface
 */
export class CompositeDataV2ControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDeviceWithMeasurements(id: number, options?: RawAxiosRequestConfig) {
        return CompositeDataV2ControllerApiFp(this.configuration).getDeviceWithMeasurements(id, options).then((request) => request(this.axios, this.basePath));
    }
}

